import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: 'How long does it take to get listed?',
    answer: 'Free listings are reviewed and published within 7 days. Featured listings go live within 48 hours, and Sponsored listings within 24 hours.',
  },
  {
    question: 'What happens after I pay?',
    answer: 'After payment, send us your tool details using the submission form below. We\'ll review your tool, apply your badge and placement, and notify you by email once it\'s live.',
  },
  {
    question: 'Can I upgrade my listing later?',
    answer: 'Yes. If you start with a free listing, you can upgrade to Featured or Sponsored at any time by paying the difference — just contact us after submitting.',
  },
  {
    question: 'Is my tool a good fit for ToolNova?',
    answer: 'ToolNova focuses on genuinely useful AI-powered tools across all categories. If your tool uses AI in a meaningful way and solves a real problem, it\'s likely a good fit.',
  },
];

export default function SubmitFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(prev => (prev === idx ? null : idx));
  };

  return (
    <section className="px-4 sm:px-6 lg:px-8 pb-20">
      <div className="max-w-3xl mx-auto">

        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 bg-gradient-to-r from-white via-gray-100 to-gray-300 bg-clip-text text-transparent">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-gray-400">
            Got a question? Here are the most common ones.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className={`rounded-xl border transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? 'bg-gray-900/60 border-teal-500/30'
                    : 'bg-gray-900/30 border-gray-800/60 hover:border-gray-700/80'
                }`}
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span className={`text-sm font-semibold leading-snug transition-colors duration-200 ${isOpen ? 'text-teal-400' : 'text-white'}`}>
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                    <i className={`ri-arrow-down-s-line text-lg ${isOpen ? 'text-teal-400' : 'text-gray-400'}`}></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                  } overflow-hidden`}
                >
                  <p className="px-6 pb-5 text-sm text-gray-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
